import React, { Component } from 'react';

import api from '../../../api/';

import Modal from "./Modal.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"

/* Declaracion de Componente Clase */
class Permisos extends Component {
    constructor(props) {
        super(props);
        // columnas que utiliza React-Table-V6 enmascarado como ParadigmaTable
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Descripcion",
                    id: "descripcion",
                    accessor: d => d.descripcion,
                    show: true,
                },
                {
                    Header: "Padre",
                    id: "padre",
                    accessor: d => (d.padre ? d.padre.nombre : ""),
                    show: true,
                },
            ]
        };
    }

    render() {
        const { modernTheme } = this.props;
        // Definicion del ParadigmaTable, con la columna y con los botones que abren el modal.
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE"/>,
                        permission: 'superadmin',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'superadmin',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'superadmin',
                    }
                ]}
                depth={1}
                apiUrl={api.usuarios.permisos}
                columns={this.state.columns}
                exportUrl={api.usuarios.permisos}
                title={"Permisos"}
            />
        );
    }
}

export default Permisos;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Permisos/Permisos.js